<template>
  <div :class="(isFloating ? 'form-floating disabled-field' : 'disabled-field') + ' mb-'+mb">
    <div class="form-control form-control-solid">
      {{value === null || value === undefined || value === '' ? '&nbsp;' : value}}
    </div>
    <span :class="{ required: required }">{{placeholder === null || placeholder === undefined || placeholder === '' ? '&nbsp;' : placeholder}}</span>
  </div>
</template>

<script>
export default {
  name: 'DisabledField',
  props: {
    mb: {
      type: [String, Number],
      default: 0
    },
    value: {
      type: [String, Number, Boolean, Object],
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    isFloating: {
      type: Boolean,
      default: true
    },
  }
}
</script>

<style scoped>

</style>